
<template>

<div class="info-wrapper" >
    <div
            class="info-container"
            v-if="info"
            :class="[
                  { 'mt-4': isRM },
                  {'is-options-info':hasOptions},
                  { 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) },
                  { 'tablet-version': versionTablet && (isHeaderInfo || hasOptionsFormation) },
                ]"
    >
        <div class="subtitle-wrapper">
            <div :class="[{ 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) }]">
                <h4
                        :class="[
                      'title',
                      componentStyle.options + '-option',
                      { 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) },
                    ]"
                >
                    {{ info.title }}
                </h4>
                <div
                        :class="[
                      'metadata-container votes',
                       componentStyle.options  + '-option',
                      { 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) },
                      { 'desktop-version': !version && !(isHeaderInfo || hasOptionsFormation) },
                    {'is-mg': isMG && !hasOptionsTv},
                    ]"

                        v-if="hasOptionsFormation"
                >
                    <div class="info" v-if="isHeaderInfo">
                        <star-rating v-model="getNbRatingStar"  ></star-rating>
                    </div>
                    <div
                            class="info"
                            :class="[
                        { 'desktop-version': version && (isHeaderInfo || hasOptionsFormation) },
                        { 'mobile-version': !version && (isHeaderInfo || hasOptionsFormation) },
                      ]"
                >
                    <font-awesome-icon class="icon" :icon="['far', 'eye']" />
                    {{ info.nbviews }}
                </div>
            </div>
        </div>
        <div class="position-relative">
            <VuePerfectScrollbar class="scroll-area" ref="ps" style="height: 120px">
                <p class="description">
                    <span id="description"> {{ info.description }}</span>
                </p>
            </VuePerfectScrollbar>
            <div  class="read-more" v-if="showMore && !hasOptions">
                    <span v-if="descriptionVisible" class="read-more__less" @click="$emit('readLess')">
                      {{ $t('buttons.see_less') }}</span
                    >
                    <span v-else="descriptionVisible" class="read-more__more" @click="$emit('readMore')">
                      {{ $t('buttons.see_more') }}</span
                    >
            </div>
            </div>
        </div>

        <div
                :class="[
                    'metadata-container',
                    componentStyle.options + '-option' ,
                    { 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) },
                    {'is-mg': isMG},
                     {'is-options-info': hasOptions},
                     {'is-options-formation': hasOptionsFormation || !isMG},
                  ]"
        >
            <div class="info duration" :class="[
            { 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) },
            {'is-options-info':hasOptions}
            ]">
                <font-awesome-icon class="icon" :icon="['far', 'clock']" />
                {{ info.duration }}
            </div>
            <div
                    class="info date"
                    :class="[
                    { 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) },
                     {'is-options-info':hasOptions}
                    ]"
            >
                <font-awesome-icon class="icon " :icon="['far', 'calendar-alt']" />
                {{ info.date | moment(' DD/MM/YYYY ') }}
            </div>
            <div
                    class="info views"
                    :class="[
                      { 'desktop-version': !version && (isHeaderInfo || hasOptionsFormation) },
                      { 'mobile-version': version && (isHeaderInfo || hasOptionsFormation) },
                       {'is-options-info':hasOptions}
                    ]"
            >
                <font-awesome-icon class="icon" :icon="['far', 'eye']" />
                {{ info.nbviews }}
            </div>
        </div>
    </div>
    <div class="btns-wrapper" v-if="isPlayerReady && info && !isMG">
        <button class="btn-embed" @click="clickModal">
            <img
                    height="16"
                    src="data:image/svg+xml;base64,
    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"
            />
            {{ $t('buttons.integrate') }}
        </button>
        <div class="canLike" v-if="canLike">
            <b-button
                    size="sm"
                    :class="{ liked: videoLiked, like: !videoLiked }"
                    @click="updateLike(1)"
            >
                <font-awesome-icon v-if="!videoLiked" :icon="['far', 'thumbs-up']" />
                <font-awesome-icon v-if="videoLiked" :icon="['fas', 'thumbs-up']" />
                {{ nbLike }}
            </b-button>

            <b-button
                    size="sm"
                    :class="{ liked: videoDisLiked, like: !videoDisLiked }"
                    @click="updateLike(-1)"
            >
                <font-awesome-icon v-if="!videoDisLiked" :icon="['far', 'thumbs-down']" />
                <font-awesome-icon v-if="videoDisLiked" :icon="['fas', 'thumbs-down']" />
                {{ nbDisLike }}
            </b-button>
        </div>
        <div class="social-share-wrapper" v-if="componentStyle.header === 'large'">
            <social-sharing
                    :url="videoMedia.link_embed"
                    :title="info.title"
                    hashtags="Empreinte"
                    inline-template
            >
                <div class="social-media-container">
                    <network network="facebook">
                        <div class="social-icon facebook">
                            <font-awesome-icon :icon="['fab', 'facebook-square']" />
                        </div>
                    </network>
                    <network network="twitter">
                        <div class="social-icon twitter">
                            <font-awesome-icon :icon="['fab', 'twitter-square']" />
                        </div>
                    </network>
                    <network network="linkedin">
                        <div class="social-icon linkedin">
                            <font-awesome-icon :icon="['fab', 'linkedin']" />
                        </div>
                    </network>
                </div>
            </social-sharing>
        </div>
    </div>
</div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import ComponentVideo from '~/node_modules/component-video/src/components/Componentplay.vue';
    import ModalExport from '~/node_modules/modal-export/src/components/Component.vue';
    import SpinnerLoader from './common/SpinnerLoader';
    import StarRating from 'vue-star-rating';
    import VueMoment from 'vue-moment';
    import * as moment from 'moment';
    import 'moment/locale/pt-br';
    import Mixin from '@/mixins/Mixin';
    import HorizantalCardCarousel from './HorizantalCardCarousel';

    export default {
        name: 'infoWrapper',
        components: {
            ComponentVideo,
            ModalExport,
            VuePerfectScrollbar,
            SpinnerLoader,
            StarRating,
            VueMoment,
            moment,
            HorizantalCardCarousel,

        },
        props: {
            info:'',
            player: {
                type:Object,
                default:{}
            },
        },
        mixins: [Mixin],
        data() {
            return {
                player: {},
                shareHtml: '',
               // info: '',
                interactions: [],
                loading: false,
                check: false,
                fail: false,
                visible: false,
                required: false,
                embedUrlLecture: true,
                OptionInteraction: true,
                showMore: false,
                descriptionVisible: false,
                descriptionTruncate: 200,
                playerSkin: 'dark',
                cdnReady: true,
                version: false,
                versionTablet: false,
                tokenUser: '',
                canLike: process.env.LIKE,
            };
        },
        computed: {
            ...mapGetters({
                currentVideo: 'videos/getCurrentVideo',
                videoMedia: 'videos/getVideoMedia',
                isFullWidth: 'layout/isFullWidth',
                isSideNav: 'layout/isSideNav',
                componentStyle: 'layout/getComponentStyle',
                videos: 'videos/getAllVideos',
                playerSkin: 'layout/getCurrentSkinPlayer',
                videoLiked: 'videos/getVideoLike',
                videoDisLiked: 'videos/getVideoDisLike',
                isVideoHd: 'layout/getIsVideoHd',
                isPlayerCDN: 'common/isPlayerCDN',
                isHeaderInfo: 'layout/isHeaderInfo',
                getNbRatingStar: 'videos/getNbRatingStar',
                isLoading: 'videos/getLoading',
                currentPage: 'videos/getCurrentPage',
                nbLike: 'videos/getNbLike',
                nbDisLike: 'videos/getNbDisLike',
                hasOptions: 'layout/hasOptions',
                hasOptionsTv: 'layout/hasOptionsTv',
                hasOptionsFormation: 'layout/hasOptionsFormation'
            }),
            isMG(){
              return process.env.CLIENT ? true :  false
            },
            canComment() {
                return process.env.COMMENTS;
            },

            isPlayerReady() {
                return this.currentVideo.cryptext && this.player;
            },
            isRM() {
                return this.isPlayerReady && this.currentVideo.type === 'isRM';
            },
        },
        watch: {
            currentVideo(video) {
                this.cdnReady = false;
                setTimeout(() => {
                    this.cdnReady = true;
                }, 100);
                if (this.isHeaderInfo) {
                    this.infoDetails(video);
                }
            },
        },
        methods: {
            ...mapActions('videos', ['setCurrentVideo', 'getVideoMediaById', 'updateVotes','getCryptedUrl']),

            infoDetails(param) {
                this.$Progress.finish();
                this.info = param;
                this.updateVideoHeight();
                this.updateReadMore();
            },
            clickModal() {
                this.$refs.exportModal.show();
            },
            updateVideoHeight() {
                const videoWrapper = document.querySelector('.video-wrapper.full-width');
                const videoContainer = document.querySelector('.video-container');
                const uepPlayer =
                    document.querySelector('.uep_player_v2') || document.querySelector('.iframe-video');
                const namePlayer = document.querySelector('#name_player');

                //const infoWrapper = document.querySelector('.info-wrapper-simple');
                const flashPlayer = document.querySelector('object.vjs-tech');
                const videoJS = document.querySelector('.video-js');
                const html5Video = document.querySelector('.video-js video.vjs-tech');
                try {
                    if (videoWrapper && !this.isHeaderInfo) {
                        if (this.isFullWidth && this.isVideoHd)
                            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
                        else videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 24)}px`;
                    } else {
                        if (window.innerWidth < '768') {
                            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
                            videoWrapper.style.maxHeight = ``;
                        } else {
                            videoWrapper.style.maxHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
                            videoWrapper.style.minHeight = ``;
                        }
                    }
                    const height = `${videoContainer.offsetWidth * (9 / 16)}px`;
                    if (uepPlayer) uepPlayer.style.height = height;
                    namePlayer.style.height = height;
                    if (videoJS) {
                        videoJS.style.minHeight = '100%';
                    }
                    if (
                        (flashPlayer ||
                            navigator.userAgent.indexOf('MSIE') !== -1 ||
                            navigator.appVersion.indexOf('Trident/') > -1) &&
                        !html5Video
                    ) {
                        flashPlayer.setAttribute('style', `height:${height} !important`);
                    }
                } catch (e) {
                    // HACK for IE 11
                    setTimeout(() => {
                        this.updateVideoHeight();
                    }, 3000);
                }
                setTimeout(() => {
                    this.updateReadMore();
                }, 100);
            },
            updateReadMore() {
                const infoWrapper = document.querySelector('.info-wrapper');
                const videoJS = document.querySelector('.video-container');
                const titleEl = document.querySelector('.info-container .title');
                const descriptionEl = document.querySelector('.info-container .description');
                let metadataEl = document.querySelector('.metadata-container');
                if (this.isHeaderInfo) {
                    metadataEl = document.querySelectorAll('.metadata-container.info-header');
                }
                const btnEmbedEl = document.querySelector('.btns-wrapper');
                if (videoJS) {
                    const videoHeight = videoJS.offsetHeight;
                    let descriptionHeight = videoHeight;

                    if (titleEl) {
                        let { height, marginTop, marginBottom } = window.getComputedStyle(titleEl);
                        descriptionHeight -=
                            parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
                    }

                    if (metadataEl && !this.isHeaderInfo) {
                        descriptionHeight -= metadataEl.offsetHeight;
                    } else {
                        if (metadataEl != null) {
                            metadataEl.forEach(metaData => {
                                descriptionHeight -= metaData.offsetHeight;
                            });
                        }
                    }
                    if (btnEmbedEl) {
                        let { height, marginTop, marginBottom } = window.getComputedStyle(btnEmbedEl);
                        descriptionHeight -=
                            parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
                    }
                    if (descriptionEl) {
                        this.showMore = descriptionEl.offsetHeight > 120;
                    }

                    this.version = window.innerWidth < 768;
                    this.versionTablet = 768 <= window.innerWidth <= 992;
                    if (this.$refs.ps) {
                        if (this.showMore) {
                            if (this.descriptionVisible) {
                                if (this.isSideNav  || this.hasOptions) {
                                    this.$refs.ps.$el.style.height = `${descriptionHeight}px`;
                                } else {
                                    this.$refs.ps.$el.style.height = '300px';
                                }
                            } else {
                                this.$refs.ps.$el.style.height = '120px';
                            }
                        } else {
                            this.$refs.ps.$el.style.height = 'auto';
                        }
                    }
                    if (infoWrapper && !this.hasOptionsTv) {
                        if (this.isSideNav  || this.hasOptions) {
                            infoWrapper.style.height = `${videoHeight}px`;
                        } else {
                            infoWrapper.style.height = 'auto';
                        }
                    }
                }
            },
            readDesc(isVisible) {
                this.descriptionVisible = isVisible;
                this.updateReadMore();
                setTimeout(() => {
                    this.$refs.ps.update();
                }, 100);
            },
            updateLike(vote) {
                let self = this;
                var typeVote =
                    (this.videoLiked && vote == 1) || (this.videoDisLiked && vote == -1) ? 0 : vote;
                var params = { video: this.currentVideo.id, user: this.tokenUser, vote: typeVote };
                self.updateVotes(params);
            },
        },
        created() {},
        mounted() {
            window.eventhub.$on('update-ps',(isVisible)=>{
                this.readDesc(isVisible)
            })
            this.$nextTick(() => {
                this.updateVideoHeight();
                this.updateReadMore();
                if (this.$cookies.isKey('tokenUserFo')) {
                    this.tokenUser = this.$cookies.get('tokenUserFo');
                } else {
                    this.tokenUser = this.makeToken();
                    this.$cookies.set('tokenUserFo', this.tokenUser);
                }
            });
            window.addEventListener('resize', () => {
                this.updateVideoHeight();
                this.updateReadMore();
            });
        },

    };
</script>
<style lang="scss">
    @import '../assets/scss/_variables';
    @import '../assets/scss/mix.scss';
    .info-wrapper {
        display: flex;
        align-items: start;
        justify-content: space-between;
        flex-direction: column;
        &.has-options-tv{
            .info-container {
                display: flex;
                flex-direction: row !important;
                @media screen and (max-width: 992px) {
                    flex-direction: column !important;

                }
            }
        }
        .info-container {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: space-between;
            .subtitle-wrapper{
                display: flex;
                flex-direction: column;
                width: 100%;
            }
            &.is-options-info{
                height: 100%;
                position: relative;
            }
            .mobile-version {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                /*.metadata-container {*/
                /*align-items: flex-start;*/
                /*.info {*/
                /*padding-right: 2em;*/
                /*&.mobile-version {*/
                /*padding: 0 0 0 1em;*/
                /*}*/
                /*.icon {*/
                /*margin-right: 0.5em;*/
                /*}*/
                /*}*/
                /*}*/
            }
            .title {
               &:not(.formation-option) {
                    @include hasColorTitre(var(--title-color));
                }
                &.formation-option.mobile-version {
                    @include hasColorTitre(var(--title-color));
                }

                margin-top: 0.2em;
                margin-bottom: 0.8em;
                &.formation-option {
                    margin-top: 0;
                }
            }

            .description {
                color: #435765;
                font-size: 0.9em;
                word-break: break-word;
                padding-bottom: 20px;
                span {
                    white-space: pre-line;
                }
            }
            .read-more {
                width: 100%;
                background-image: linear-gradient(
                                to top,
                                rgb(250, 250, 250),
                                rgba(250, 250, 250, 0.9) 50%,
                                transparent
                );
                z-index: 1;
                font-size: 0.8em;
                color: #8c8c8c;
                text-decoration: underline;
                margin-top: 0;
                bottom: 0;
                padding: 20px 0 5px;
                position: absolute;
                span {
                    cursor: pointer;
                }
            }

            .metadata-container {
                 &:not(.is-mg) {
                    @include hasColorTitre(var(--title-color));
                }
                font-size: 0.8em;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 0.8em;
                align-items: center;
                flex-shrink: 0;
                position: relative;
                &.is-options-formation{
                    border-top: 1px solid #c5c6c7;
                }
                ////verifier
                /*&.info-header:not(.mobile-version) {*/
                /*border-top: 1px solid #c5c6c7;*/
                /*padding-top: 0.8em;*/
                /*align-items: center;*/
                /*}*/
                &.is-options-info{
                    /*position: absolute;*/
                    /*bottom: 0;*/
                    width: 100%;
                    height: 30px;
                }
                &.formation-option.desktop-version:not(.mobile-version) {
                    border-top: none;
                    padding: 0 0 0.8em 0;
                }
                &.mobile-version {
                    justify-content: flex-start;
                }
                &.tv-option{
                    align-items: start !important;
                    .info{
                        text-align: left;
                        font-family:'Roboto-Light' ;
                        font-size: 15px;
                        letter-spacing: 0px;
                        color: #353535;
                        opacity: 1;
                        padding: 0 1em;
                        &.duration{
                            order:2
                        }
                        &.date{
                            order:1
                        }
                        &.views{
                            order:3
                        }
                    }
                    @media screen and (max-width: 992px) {
                        align-items: center !important;
                        justify-content: flex-end;
                    }
                }
                &.votes {
                    border-top: none;
                }
                .info {
                    display: flex;
                    align-items: center;
                    /*@media (max-width: 768px) {*/
                    /*.mobile-version{*/
                    /*display:flex  !important;*/
                    /*}*/
                    /*.desktop-version{*/
                    /*display:none  !important;*/
                    /*}*/
                    /*}*/
                    &.desktop-version {
                        display: none;
                    }
                    &.mobile-version {
                        display: block;
                        padding: 0 1em 0 0;
                        .icon {
                            margin-right: 0.5em;
                        }
                    }
                    &.is-options-info{
                            &.date{
                                order : 1
                            }
                            &.duration{
                                order : 2
                            }
                            &.views{
                                order : 3
                            }

                      }
                    .icon {
                        font-size: 1.2em;
                        margin-right: 0.2em;
                    }
                }
            }
        }
        .btns-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 0.8em;
            width: 100%;
            @media (max-width: 1199px) {
                flex-direction: column;
                align-items: start;
            }
            .btn-embed {
                border-radius: 2px;
                border: 1px solid #a0a0a0;
                background: #eceff1;
                padding: 3px;
                cursor: pointer;
                width: 160px;
                color: rgba(0, 0, 0, 0.8);
                flex-shrink: 0;
            }
            .liked {
                color: #fff;
                background-color: var(--primary-color);
                border-color: var(--primary-color);
                &:active,
                &:focus {
                    color: #fff;
                    background-color: var(--primary-color);
                    border-color: var(--primary-color);
                    box-shadow: none;
                }
                &:hover {
                    color: var(--primary-color);
                    background-color: #fff;
                    border-color: var(--primary-color);
                    box-shadow: none;
                }
            }
            .like {
                color: var(--primary-color);
                background-color: #fff;
                border-color: var(--primary-color);
                box-shadow: none;

                &:active,
                &:focus {
                    color: var(--primary-color);
                    background-color: #fff;
                    border-color: var(--primary-color);
                    box-shadow: none;
                }
                &:hover {
                    color: #fff;
                    background-color: var(--primary-color);
                    border-color: var(--primary-color);
                    box-shadow: none;
                }
            }
            .social-share-wrapper {
                .social-media-container {
                    display: flex;
                    align-items: center;
                    /deep/ .social-icon {
                        font-size: 1.8em;
                        margin: 0 0.1em;
                        cursor: pointer;
                        &.facebook {
                            color: #3b5998;
                        }
                        &.twitter {
                            color: #55acee;
                        }
                        &.linkedin {
                            color: #0077b5;
                        }
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/infoWrapper.vue